import { render, staticRenderFns } from "./update-ins-record-settings.vue?vue&type=template&id=14975fb8&scoped=true"
import script from "./update-ins-record-settings.vue?vue&type=script&lang=js"
export * from "./update-ins-record-settings.vue?vue&type=script&lang=js"
import style0 from "./update-ins-record-settings.vue?vue&type=style&index=0&id=14975fb8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14975fb8",
  null
  
)

export default component.exports